export const GET_MEETING_ACCESS = 'GET_MEETING_ACCESS';
export const GET_MEETING_PUBLIC_ACCESS = 'GET_MEETING_PUBLIC_ACCESS';
export const GET_MEETING = 'GET_MEETING';
export const GET_MEETING_MESSAGES = 'GET_MEETING_MESSAGES';
export const MEETING_ERROR = 'MEETING_ERROR';
export const GET_MEETING_FIELDS = 'GET_MEETING_FIELDS';
export const GET_MEETING_FILES_FIELDS = 'GET_MEETING_FILES_FIELDS';
